<template>
    <div class="h-100">
        <embed src="/docs/terms.pdf" width="100%" height="100%" type="application/pdf">
    </div>
</template>